import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'

export default function useValueEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { getItem, updateItem } = useLambda()
  const value = ref({})
  const isSubmitting = ref(false)
  const query = { _id: oid(route.value.params.id) }
  const collection = 'value'

  const show = async () => {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })
      if (!item) throw new Error('Item not found')

      value.value = item
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.value_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async data => {
    isSubmitting.value = true

    try {
      const action = { $set: {
        name: data.name?.value || '',
      }}

      await updateItem({ collection, query, action })

      showSuccessMessage(i18n.t('message.value_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.value_update_error'))
    } finally {
      router.push({ name: 'organization-value-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    value,
    isSubmitting,
  }
}
